import React from 'react';

import PropTypes from 'prop-types';

import { languages } from 'const';

import MainFont from 'ui/typography/mainFont';

import { FlagImage, ListItem, PopupWrapper } from './style';

const LanguagesPopup = ({ handleLanguageFallback }) => {
  const handleLanguageChoice = lang => {
    // calls the fucntion for the dispatch of the selection of the language
    handleLanguageFallback(lang);
  };
  return (
    <PopupWrapper>
      {languages()?.map((item, index) => (
        <ListItem key={index} onClick={() => handleLanguageChoice(item.code)}>
          <FlagImage src={item.flag} />
          <div>
            <MainFont
              type="accountPopupText"
              configuration={{ fontWeight: 'medium' }}
            >
              {item.label}
            </MainFont>
          </div>
        </ListItem>
      ))}
    </PopupWrapper>
  );
};

LanguagesPopup.propTypes = {
  handleLanguageChoice: PropTypes.func
};

export default LanguagesPopup;
